import { useField } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';

export const TextInput = ({
  label, subtext, styles = {}, isScreening = false, ...props
}) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  return (
    <Form.Group className={styles.formGroup}>
      <Form.Label
        htmlFor={props.id || props.name}
        className={styles.formLabel}
      >
        {label || ''}
      </Form.Label>
      <Form.Control
        aria-describedby={`${props.name} Text Input`}
        onChange={props.handleChange}
        {...(!isScreening ? {
          isValid: meta.value && (meta.touched && !meta.error),
        }
          : {})}
        isInvalid={meta.error}
        className={styles.formControl}
        {...field}
        {...props}
      />
      {subtext && <Form.Text muted>{subtext}</Form.Text>}
      <Form.Control.Feedback type="invalid" className={styles.formInvalid} muted>{meta.error}</Form.Control.Feedback>
    </Form.Group>
  );
};

export const ScreeningTextInput = ({
  label, subtext, styles = {}, ...props
}) => (
    <>
      <TextInput
        label={label}
        subtext={subtext}
        styles={styles}
        isScreening
        {...props}
      />
    </>
);
